export const getCurrentSubdomain = () => window.location.hostname.split('.')[0]
